'use client'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

import { usePathname } from '@/i18n/routing'
import { schedulePathAwareNonCriticalWork } from '@/lib/perf/scheduleNonCriticalWork'

const SalesCard = dynamic(() => import('./SalesCard'), { ssr: false })

export default function SalesCardLazy() {
  const pathname = usePathname()
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    return schedulePathAwareNonCriticalWork(pathname, () => {
      setShouldLoad(true)
    })
  }, [pathname])

  if (!shouldLoad) {
    return null
  }

  return <SalesCard />
}
